import { memo } from "react";

import { IExams } from "../../../models/exams";
import { shouldUsePdfSerial } from "../../../utils/examFormat.util";
import ExamsDownload from "../ExamsDownload/ExamsDownload";
import { ExamsResultLabPdf } from "../ExamsResultLabPdf/ExamsResultLabPdf";
import { Reports } from "../Reports/Reports";
import { ReportsPdfSerial } from "../ReportsPdfSerial/ReportsPdfSerial";

interface IExamReportActionProps {
  exam: IExams;
  cdnUrl: boolean;
  checkPdfSerialOnNullFormat: boolean;
  individualId?: string;
}

const ExamReportAction: React.FC<IExamReportActionProps> = ({
  exam,
  cdnUrl,
  checkPdfSerialOnNullFormat,
  individualId,
}) => {
  const hasMedicalCertificateContent = !!exam.medicalCertificateContent?.length;

  if (
    shouldUsePdfSerial(exam.formatTypeCode, checkPdfSerialOnNullFormat)
  ) {
    return <ReportsPdfSerial identifier={exam.id} cdnUrl={cdnUrl} />;
  }

  if (exam.type === "NAO-LABORATORIAL") {
    if (exam.formatTypeCode === "3") {
      return (
        <Reports
          identifier={exam.id}
          id={exam.id.toString()}
          examType={exam.type}
          date={exam.medicalCertificateDate}
          individualId={individualId}
          cdnUrl={cdnUrl}
        />
      );
    }

    if (!hasMedicalCertificateContent) {
      return <>-</>;
    }

    return (
      <ExamsDownload
        id={exam.id.toString()}
        examType={exam.type}
        date={exam.medicalCertificateDate}
        individualId={individualId}
      />
    );
  }

  if (exam.formatTypeCode === "3") {
    return (
      <ExamsResultLabPdf
        exam={exam}
        cdnUrl={cdnUrl}
        individualId={individualId}
      />
    );
  }

  if (!hasMedicalCertificateContent) {
    return <>-</>;
  }

  return (
    <ExamsDownload
      id={exam.id.toString()}
      examType={exam.type}
      date={exam.medicalCertificateDate}
      individualId={individualId}
    />
  );
};

export default memo(ExamReportAction);
